<template>
    <md-tooltip md-delay="200" md-direction="bottom" :style="{left: `${mousePosition}px`, transform: `translateX(-50%)`}">
        {{ item.project ? item.project.name+" - " : ""}} {{ formatDate(item.start) }} - {{ formatDate(item.end) }}
    </md-tooltip>
</template>

<script>


    import dayjs from "dayjs";

    export default {
        name: "Test",
        props: {
            data: Object,
            item: Object,
            currentTime: dayjs,
            updateTimeLines: Function,
            cellHeight:Number,
            startTimeOfRenderArea:Number,
            mousePosition: Number
        },
        
        methods: {
            formatDate(date) {
                return moment(date).format("DD.MM.YYYY HH:mm");
            }
        }
    };
</script>

<style lang="scss" scoped>
    .middle {
        flex: 1;
        text-align: center;
        padding-left: 5px;
    }
    .runTime {
        display: flex;
        flex-direction: column;
    }
    .plan {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        height: 80%;
        border: 1px solid #f0f0f0;
        border-radius: 5px;
        color: #333333;
        padding-left: 5px;
        font-size: 0.8rem;
        // opacity: 0.8;
    }
    .detail {
        .header{
            text-align: center;
            font-size: 1rem;
        }
    }
    .detail ul {
        list-style: none;
        padding: 0px;
        li{
            span{
                display: inline-block;
                width: 80px;
                color: #777;
                font-size: 0.8rem;
            }
            span:first-child{
                text-align: right;
            }
            span:last-child{
            }
        }
    }
</style>
